import { Grid, Text } from '@chakra-ui/react';
import { Field, useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import { Textarea, colors } from 'ui-components';
import { TalentValues } from '~/screens/AddTalent/ProfileInformation';

export const Bio: React.FC = React.memo(() => {
  const { values, touched } = useFormikContext<TalentValues>();

  const { sPBioLoading, isBioFromSmartData, bioLength } = useMemo(() => {
    const sPBio = values.smartData?.bio?.value;
    const sPBioLoading =
      !values.bio && values.smartData?.bio?.status === 'pending';
    const isBioFromSmartData =
      values.bio && !touched.bio ? sPBio === values.bio : false;
    const bioLength = values.bio?.length || 0;

    return { sPBioLoading, isBioFromSmartData, bioLength };
  }, [values.smartData?.bio, values.bio, touched.bio]);

  return (
    <Grid gap={3}>
      <Field
        as={Textarea}
        label="Bio"
        data-testid="bio"
        name="bio"
        maxLength={550}
        isSmartData={sPBioLoading || isBioFromSmartData}
        isSmartDataLoading={sPBioLoading}
        track-id="foam-talent-profileInformationModal-biography"
        clearButtonProps={{
          'aria-label': 'Clear bio text',
          trackId: 'foam-talent-profileInformationModal-biography-clear',
        }}
      />
      <Text color={colors.primary[300]} size="0.875rem">
        {bioLength}/550 characters
      </Text>
    </Grid>
  );
});
